define('commons/location-level',['jquery', 'chosen'], function($) {

    var LocationLevel = function(container, options) {

        this.settings = {
            // [country code, level 1 code, level 2 code, ...]
            data: [],
            url: "/location/list"
        };

        $.extend(this.settings, options);

        this.$container = $(container);
        this.$form = null;
        this.selectedNodes = [];
        this.deep = 0;

        this.updateWith(this.settings.data);
    };

    LocationLevel.prototype.updateWith = function(data) {
        this.clean(0);
        this.lock = data.length;
        this.request(null, data);
    };
    
    /**
     * data: {
     *      name: select name property,
     *      options: [
     *          {
     *              c: code,
     *              m: display name
     *              d: level deep (optional)
     *          },
     *          ...
     *      ]
     * }
     */
    LocationLevel.prototype.createSelectNode = function(data, selectedCode, pos) {
        var ignoreChosen = this.$container.hasClass('ignore-chosen');
        var $select = $("<select class='" + (!ignoreChosen ? "hidden accordion-ignore-chosen " : "") + "simple-select' data-placeholder='All' name='" + data.name + "'></select>");
        $select.append($("<option value='-1'>" + (ignoreChosen ? "All" : "") + "</option>"));
      
        var length = data.options.length;
        for (var i = 0; i < length; i++) {
            var opt = data.options[i];
            $select.append($("<option value='" + opt.c + "'" + (typeof opt.d != "undefined" ? " data-d=" + opt.d : "") +
                    (opt.c == selectedCode ? " selected='selected'" : "") + ">" + opt.m + "</option>"));
        }
        $select.change($.proxy(function() {
            var $option = $select.find("option:selected");
            var deep = parseInt($option.attr("data-d"));
            this.clean(pos + 1);
            if ($select.val() == -1) {
                this.lock = pos;
                return;
            }
            this.lock = pos + 1;
            if (deep >= 0) {
                this.deep = deep;
            }
            if (pos <= this.deep) {
                var data = [];
                for (var i = 0; i < this.selectedNodes.length; i++) {
                    data.push(this.selectedNodes[i].val());
                }
                this.request(data);
            }
        }, this));

        this.clean(pos);
        this.selectedNodes[pos] = $select;
        this.$container.append($select);
       
        if(!this.$container.hasClass('ignore-chosen') && this.$container.is(':visible')){
            // Turn all <select> as chosen select
            $select.removeClass('hidden tmp-ignore-chosen').chosen({
                disable_search_threshold: 7,
                search_contains : true,
                allow_single_deselect: true,
                no_results_text: 'Nothing found for '
            });
        }

        if (this.$form === null) {
            this.$form = $($select[0].form);
            this.$form.find('button[type="reset"]').on("click", $.proxy(function() {
                this.clean(1);
            }, this));
        }
    };

    LocationLevel.prototype.clean = function(pos) {
        for (var i = pos; i < this.selectedNodes.length; i++) {
            var selNode = this.selectedNodes[i];
            // Workaround because of a bug in chosen code
            if (selNode.parent().find('.chosen-container').length > 0) {
                selNode.chosen('destroy');
            }
            selNode.remove();
        }
        this.selectedNodes = this.selectedNodes.slice(0, pos);
    };
    
    /**
     * result: [{
     *      c: country code,
     *      m: country name,
     *      d: level deep
     * }, ...]
     */
    LocationLevel.prototype.processCountry = function(result, selectedCode) {
        this.selectedNodes = [];
        this.createSelectNode({
            name: "country",
            options: result
        }, selectedCode, 0);
    };

    /**
     * result: [{
     *      c: level code,
     *      m: level name
     * }, ...]
     */
    LocationLevel.prototype.processLevel = function(result, selectedCode, pos) {
        if (pos <= this.lock && result.length > 0) {
            this.createSelectNode({
                name: "level_" + (pos - 1),
                options: result
            }, selectedCode, pos);
        }
    };

    /**
     * data: {
     *      
     * }
     */
    LocationLevel.prototype.request = function(data, chainData) {
        // Prepare data to send
        var d = {};
        data = data || [];
        if (data && data.length > 0) {
            d.country = data[0];
            for (var i = 1; i < data.length; i++) {
                d["level_" + (i - 1)] = data[i];
            }
        }

        // Prepare chain
        var selectedCode = null;
        if (chainData && chainData.length > 0) {
            selectedCode = chainData[0];
            chainData = chainData.slice(1, chainData.length);
        }

        $.ajax({
            type: 'GET',
            url: this.settings.url,
            dataType: "json",
            data: d,
            success: function(result) {
                if (data.length === 0) {
                    // country
                    this.processCountry(result, selectedCode);
                } else {
                    // levels
                    this.processLevel(result, selectedCode, data.length);
                }
                if (chainData && chainData.length > 0) {
                    data.push(selectedCode);
                    this.request(data, chainData);
                }
            },
            context: this
        });
    };
    return LocationLevel;
});

